<template>
    <v-container>
        <v-row class="pt-sm-8">
            <v-col md="4 aside-left" :class="{ 'pa-0': !isDesktop }" v-if="isDesktop">
                <div class="fixed-content">
                    <slot name="aside-left"></slot>
                </div>
            </v-col>
            <v-col md="8" class="main-content" :class="{ 'px-0 pt-0': !isDesktop }">
                <slot name="main"></slot>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { utilities } from "@/base/utilities"
import ScrollMagic from "scrollmagic"

export default {
    data: () => ({
        scrollController: null,
        scene: null,
        onResize: null

    }),

    mounted() {
        this.$nextTick(() => {
            // Initialize scroll controller
            this.createScrollController()
            this.addListener()
            // Sidebar width init
            if(this.isDesktop) this.sidebarWidth()
        })

    },

    destroyed() {
        this.removeListeners()
    },

    methods: {
        /*
         * Add Listeners
         */
        addListener() {
            // onResize is a debounce
            this.onResize = utilities.debounce(() => {
                // Sidebar width updation
                if(this.isDesktop) this.sidebarWidth()
            }, 250)

            window.addEventListener('resize', this.onResize)
        },
        /*
         * Remove Listeners
         */
        removeListeners() {
            window.removeEventListener('resize', this.onResize)
        },

        /* 
         * Adding scroll scenes
         */
        createScrollController() {
            //Creating controller and Adding scenes
            this.scrollController = new ScrollMagic.Controller()
            if (this.isDesktop) {
                this.pinScene()
            }

        },

        pinScene() {
            //Creating scene
            this.scene = new ScrollMagic.Scene({
                    //triggerElement: ".main-content", 
                    triggerHook: "onLeave",
                    offset: this.$store.state.common.scrollOffset
                })
                .setClassToggle(this.$el.querySelector('.fixed-content'), 'fixed-content--fixed')
                //.setPin(this.$el.querySelector('.fixed-content'))
                .addTo(this.scrollController)
        },

        /*
         * Sidebar width
         */
        sidebarWidth() {
            const sidebar = this.$el.querySelector('.fixed-content')
            const container = this.$el.querySelector('.aside-left')
            let containerWidth = container.getBoundingClientRect().width,
                containerPadding = window.getComputedStyle(container, null).getPropertyValue('padding').split('px')[0] * 2

            sidebar.style.width = (containerWidth - containerPadding) + 'px'
        }
    }
}
</script>